import React, { MouseEventHandler, useEffect } from "react";
import { shallowEqual } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useAlarmListQuery, useReadAllAlarmMutation } from "src/api/alarmAPI";
import { useAppSelector } from "src/store/actions/action";
import Body from "src/components/common/Body";
import List from "src/components/common/List";
import AlarmListItem from "src/components/alarm/AlarmListItem";
import Button from "src/components/common/Button";
import IconButton from "src/components/common/IconButton";
import SVG from "src/utils/SVG";
import styled from "styled-components";

const alarm = () => {
  const userInfo = useAppSelector((state) => state.userReduce.userInfo, shallowEqual);
  const navigate = useNavigate();
  const alarmList = useAlarmListQuery("");
  const { refetch } = useAlarmListQuery("");

  const [readAllAlarmUpdate, { isError: readAllIsError, isSuccess: readAllIsSuccess }] = useReadAllAlarmMutation();

  useEffect(() => {
    if (readAllIsError) {
      navigate("/error");
    }
  }, [readAllIsError]);

  useEffect(() => {
    if (readAllIsSuccess) {
      refetch();
    }
  }, [readAllIsSuccess]);

  const checkedAll = () => {
    readAllAlarmUpdate("");
  };

  return (
    <>
      <header>
        <div>
          <Button variant="text" className="btn-back" onClick={() => navigate(-1)}>
            알림
          </Button>
        </div>
        {userInfo.user_type === "E" && (
          <div className="btn-box">
            <IconButton btnName="알림설정" className="setting" onClick={() => navigate("/alarm-setting")}>
              <SVG name="setting" />
            </IconButton>
          </div>
        )}
      </header>

      <Body>
        {alarmList.isSuccess && alarmList.data.data.length > 0 && (
          <ButtonWrap>
            <Button variant="text" onClick={checkedAll}>
              모두 읽음 표시
            </Button>
          </ButtonWrap>
        )}
        <List pd="0 15px" itemPd="20px 0">
          {alarmList.isSuccess && <AlarmListItem data={alarmList.data.data} />}
        </List>
      </Body>
    </>
  );
};

const ButtonWrap = styled.div`
  padding: 7px 15px 0;
  text-align: right;
  button {
    font-size: 14px;
  }
`;

export default alarm;
